import { useRouterState } from '@tanstack/react-router'
import type { MouseEvent } from 'react'
import { useState } from 'react'
import { buildContactMailtoUrl } from '@/constants/contact'
import { usePrefersReducedMotion } from '@/hooks/use-prefers-reduced-motion'

export type NavbarVariant = 'home' | 'editorial'

export interface NavbarModelProps {
  variant: NavbarVariant
}

export interface NavbarLink {
  label: string
  href: string
  transitionDelayMs: number
}

const STAGGER_STEP_MS = 60

const NAVBAR_LINKS: NavbarLink[] = [
  { label: 'Catálogo', href: '/catalogo' },
  { label: 'Ocasiões', href: '/ocasioes/aniversario' },
  { label: 'Sobre', href: '/sobre' },
].map((link, index) => ({
  ...link,
  transitionDelayMs: index * STAGGER_STEP_MS,
}))

const OVERLAY_CTA_DELAY_MS = NAVBAR_LINKS.length * STAGGER_STEP_MS

const HOME_PATHNAME = '/'

export function useNavbarModel({ variant }: NavbarModelProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const pathname = useRouterState({
    select: (state) => state.location.pathname,
  })
  const reducedMotion = usePrefersReducedMotion()

  function toggleMenu() {
    setIsMenuOpen((current) => !current)
  }

  function closeMenu() {
    setIsMenuOpen(false)
  }

  function handleWordmarkClick(event: MouseEvent<HTMLAnchorElement>) {
    closeMenu()
    if (pathname !== HOME_PATHNAME) return
    if (
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return
    }
    event.preventDefault()
    window.scrollTo({ top: 0, behavior: reducedMotion ? 'auto' : 'smooth' })
  }

  return {
    variant,
    links: NAVBAR_LINKS,
    overlayCtaDelayMs: OVERLAY_CTA_DELAY_MS,
    isMenuOpen,
    toggleMenu,
    closeMenu,
    handleWordmarkClick,
    contactUrl: buildContactMailtoUrl(),
  }
}
